import React from "react";
import FeatureProduct from "./FeatureProduct";

const Products = () => {
  return (
    <>
      <div className="container">
        <h1>Products Page</h1>
        <FeatureProduct />
      </div>
    </>
  );
};

export default Products;
